export const techniqueBlur = [
	{
		icon: '🔹',
		subtitle: 'techniqueData.subtitle1',
	},
	{
		icon: '🔹',
		subtitle: 'techniqueData.subtitle2',
	},
	{
		icon: '🔹',
		subtitle: 'techniqueData.subtitle3',
	},
	{
		icon: '🔹',
		subtitle: 'techniqueData.subtitle4',
	},
	{
		icon: '🔹',
		subtitle: 'techniqueData.subtitle5',
	},
];
